import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: 'By month', value: 'month'},
    {label: 'By year', value: 'year'}
]

export default function SelectMonthYearRanges({previous=false, ...props}) {

    const myProps = {
        label: 'Select date',
        options: OPTIONS,
        isClearable: false, 
        firstSelect: true, 
        isMulti: false,
        icon: {icon: 'filter'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}